import { useAppDispatch, useAppSelector } from "../storeHooks";
import { workforceActions } from "../../redux/Ldb/actions/workforceActions";

const useUpdateAgentStatus = (): useUpdateAgentStatusProp => {
    const dispatch = useAppDispatch();

    const { updatingAgentStatus, updateAgentStatusSuccess, updateAgentStatusFailure } =
        useAppSelector((state) => state.workforce);

    async function updateAgentStatus(
        agentId: string,
        data: Record<string, any> | Array<Record<string, any>>
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            // Reset any previous state
            dispatch(workforceActions.resetUpdateAgentStatusSuccess());

            // Start the Redux action
            dispatch(workforceActions.updateAgentStatus(agentId, data));

            // Poll for state changes
            // const checkState = () => {
            //     const currentState = dispatch((dispatch, getState) => {
            //         const state = getState();
            //         return {
            //             isLoading: state.workforce.updatingAgentStatus,
            //             success: state.workforce.updateAgentStatusSuccess,
            //             error: state.workforce.updateAgentStatusFailure,
            //         };
            //     });

            //     if (currentState.error) {
            //         reject(currentState.error);
            //     } else if (currentState.success && !currentState.isLoading) {
            //         resolve(currentState.success);
            //     } else if (
            //         !currentState.isLoading &&
            //         !currentState.success &&
            //         !currentState.error
            //     ) {
            //         reject("Request failed without error or success response");
            //     } else {
            //         // Still loading, check again
            //         setTimeout(checkState, 100);
            //     }
            // };

            // checkState();
        });
    }

    const resetUpdateAgentStatusSuccess = () => {
        dispatch(workforceActions.resetUpdateAgentStatusSuccess());
    };

    return [
        updateAgentStatus,
        {
            isUpdating: updatingAgentStatus,
            error: updateAgentStatusFailure,
            success: updateAgentStatusSuccess,
            resetUpdateAgentStatusSuccess,
        },
    ];
};

export default useUpdateAgentStatus;

type useUpdateAgentStatusProp = [
    (agentId: string, data: Record<string, any> | Array<Record<string, any>>) => Promise<any>,
    {
        isUpdating: boolean;
        error: any;
        success: any;
        resetUpdateAgentStatusSuccess: () => void;
    }
];
